import { getPolygonsFromVectorTiles } from '@monopolio-ui/apis-library'
import { useFilterStore, usePolygonStore } from '@monopolio-ui/state-library'
import { ESearchLevel } from '@monopolio-ui/types-library'
import { useEffect } from 'react'
import { presenterPolygonProperties } from '../../utils/heatMapUtils'

const AutoSelectPolygonInSearch = (): JSX.Element => {
  const { latitude, longitude, searchLevel } = useFilterStore()

  const {
    polygonTiles,
    polygonNavigation,
    isEnabledHeatMap,
    clearPolygonNavigation,
    setPolygonNavigation,
  } = usePolygonStore()

  const autoSelectedPolygon = async (): Promise<void> => {
    if (!polygonTiles?.length || !latitude || !longitude || !searchLevel) {
      return
    }
    const { centroid } = polygonNavigation[searchLevel as keyof typeof polygonNavigation] ?? {}

    if (centroid && typeof centroid === 'object' && 'lat' in centroid && 'lng' in centroid && (centroid as {lat: number; lng: number}).lat === latitude && (centroid as {lat: number; lng: number}).lng === longitude) {
      return
    }

    const sources = polygonTiles.map(({ tiles }) => {
      switch (searchLevel) {
        case ESearchLevel.STATE:
          return tiles?.state?.id ?? ''
        case ESearchLevel.MUNICIPALITY:
          return tiles?.municipalities?.id ?? ''
        case ESearchLevel.NEIGHBORHOOD:
        case ESearchLevel.BlOCK:
        case ESearchLevel.PROPERTY:
          return tiles?.neighborhoods?.id ?? ''
        default:
          return tiles?.state?.id ?? ''
      }
    })

    const { isSuccess, data } = await getPolygonsFromVectorTiles({
      center: {
        lat: latitude,
        lng: longitude,
      },
      sources,
    })

    if (!isSuccess || !data?.length) {
      return
    }

    const nomenclature = data.map((feature: any) => {
      return presenterPolygonProperties(feature)
    })

    const [firstPolygon] = nomenclature

    clearPolygonNavigation({
      state: true,
      municipality: true,
      neighborhood: true,
    })

    setPolygonNavigation({
      properties: firstPolygon,
      level: searchLevel,
    })
  }

  useEffect(() => {
    if (
      isEnabledHeatMap &&
      searchLevel &&
      polygonTiles?.length &&
      ![ESearchLevel.BlOCK, ESearchLevel.PROPERTY].includes(searchLevel)
    ) {
      autoSelectedPolygon()
    }
  }, [searchLevel, latitude, longitude, isEnabledHeatMap, polygonTiles])

  return <></>
}

export default AutoSelectPolygonInSearch
